export default [
    {
        name: 'Convênios',
        url: '/gescon/financeiro/convenios',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-FINAN-CONV-00',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        }
    }
]
